import { Modal, Stack, Group, Badge, Alert, Button } from '@mantine/core';
import { IconArrowRight, IconAlertCircle } from '@tabler/icons-react';
import { useSurfaceZIndex } from '@ayocore/platform/client/components/surfaceZIndex';
import type { DealStatus } from '../../../../../schemas/deal-status.schema';

interface DealStatusChangeModalProps {
  opened: boolean;
  currentStatus: DealStatus | null | undefined;
  targetStatus: DealStatus | null;
  error: string | null;
  changing: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Модалка подтверждения смены статуса сделки.
 * Показывает переход текущий → новый, ошибку от сервера (если есть).
 */
export function DealStatusChangeModal({
  opened,
  currentStatus,
  targetStatus,
  error,
  changing,
  onConfirm,
  onClose,
}: DealStatusChangeModalProps) {
  // Инлайн-модалка (не через useModal): z-index из общего аллокатора,
  // иначе при открытии DealView в дравере модалка окажется под ним.
  const zIndex = useSurfaceZIndex(opened);
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title='Изменить статус сделки'
      size='sm'
      centered
      closeOnClickOutside={false}
      zIndex={zIndex}
    >
      <Stack gap='md'>
        <Group gap='sm' align='center'>
          {currentStatus ? (
            <Badge color={currentStatus.color ?? 'gray'} variant='light' size='md'>
              {currentStatus.name}
            </Badge>
          ) : (
            <Badge color='gray' variant='light' size='md'>
              Не задан
            </Badge>
          )}

          <IconArrowRight size={16} color='var(--mantine-color-dimmed)' />

          {targetStatus && (
            <Badge color={targetStatus.color ?? 'gray'} variant='filled' size='md'>
              {targetStatus.name}
            </Badge>
          )}
        </Group>

        {error && (
          <Alert icon={<IconAlertCircle size={16} />} color='red' variant='light'>
            {error}
          </Alert>
        )}

        <Group justify='flex-end' gap='sm'>
          <Button variant='light' color='gray' size='xs' onClick={onClose} disabled={changing}>
            Отмена
          </Button>
          <Button size='xs' onClick={onConfirm} loading={changing}>
            Перевести
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
